import React from "react";
import { ReactComponent as BlueBackArrow } from "../assets/images/Icons/blue-back-arrow.svg";
import { ReactComponent as Email } from "../assets/images/Icons/email.svg";
import { ReactComponent as Password } from "../assets/images/Icons/password.svg";
import { ReactComponent as CheckMark } from "../assets/images/Icons/check.svg";
import { ReactComponent as Notification } from "../assets/images/Icons/notification.svg";
import { ReactComponent as DropdownArrow } from "../assets/images/Icons/dropdown-arrow.svg";
import { ReactComponent as ToggleMenu } from "../assets/images/Icons/toggle-menu.svg";
import { ReactComponent as Cross } from "../assets/images/Icons/cross.svg";
import { ReactComponent as Pin } from "../assets/images/Icons/pin.svg";
import { ReactComponent as Dollar } from "../assets/images/Icons/dollar.svg";
import { ReactComponent as Location } from "../assets/images/Icons/location.svg";
import { ReactComponent as RightTickFilled } from "../assets/images/Icons/right-tick-filled.svg";
import { ReactComponent as ErrorFilled } from "../assets/images/Icons/error-filled.svg";
import { ReactComponent as Calender } from "../assets/images/Icons/calender.svg";
import { ReactComponent as AddCircle } from "../assets/images/Icons/add-circle.svg";
import { ReactComponent as ThreeDots } from "../assets/images/Icons/three-dots.svg";
import { ReactComponent as Edit } from "../assets/images/Icons/edit.svg";
import { ReactComponent as Delete } from "../assets/images/Icons/delete.svg";
import { ReactComponent as View } from "../assets/images/Icons/view.svg";
import { ReactComponent as CheckCircle } from "../assets/images/Icons/check-circle.svg";
import { ReactComponent as Plus } from "../assets/images/Icons/plus.svg";
import { ReactComponent as Link } from "../assets/images/Icons/link.svg";
import { ReactComponent as Message } from "../assets/images/Icons/message.svg";
import { ReactComponent as DownArrow } from "../assets/images/Icons/down-arrow.svg";
import { ReactComponent as ArrowLeft } from "../assets/images/Icons/arrow-left.svg";
import { ReactComponent as AddForm } from "../assets/images/Icons/add-form.svg";
import { ReactComponent as SendLink } from "../assets/images/Icons/send-link.svg";
import { ReactComponent as ResendLink } from "../assets/images/Icons/resend-link.svg";
import { ReactComponent as LinkedIn } from "../assets/images/Icons/linkedin.svg";
import { ReactComponent as NotAllowed } from "../assets/images/Icons/not-allowed.svg";
import { ReactComponent as Download } from "../assets/images/Icons/download.svg";
import { ReactComponent as History } from "../assets/images/Icons/history.svg";
import { ReactComponent as Search } from "../assets/images/admin-icon/search.svg";
import { ReactComponent as SelectArrow } from "../assets/images/Icons/select-arrow.svg";
import { ReactComponent as Reactivate } from "../assets/images/Icons/reactivate.svg";
import { ReactComponent as Permission } from "../assets/images/Icons/permission.svg";
import { ReactComponent as Information } from "../assets/images/vendor/information.svg";
import { ReactComponent as Address } from "../assets/images/vendor/address.svg";
import { ReactComponent as Banking } from "../assets/images/vendor/banking.svg";
import { ReactComponent as Contact } from "../assets/images/vendor/contacts.svg";
import { ReactComponent as Building } from "../assets/images/vendor/building.svg";
import { ReactComponent as ShippingBox } from "../assets/images/vendor/shipping.svg";
import { ReactComponent as Phone } from "../assets/images/vendor/phone.svg";
import { ReactComponent as Product } from "../assets/images/Icons/product.svg";
import { ReactComponent as Branch } from "../assets/images/Icons/branch.svg";
import { ReactComponent as UnitOfMeasurement } from "../assets/images/Icons/measurement.svg";
import { ReactComponent as User } from "../assets/images/Profile/icons/user.svg";
import { ReactComponent as UserRole } from "../assets/images/Icons/user-role.svg";
import { ReactComponent as SalesDetail } from "../assets/images/Icons/salesDetail.svg";
import { ReactComponent as Warning } from "../assets/images/Icons/warning.svg";
import { ReactComponent as Clone } from "../assets/images/Icons/clone.svg";
import { ReactComponent as MarkAsInactive } from "../assets/images/Icons/mark-as-inactive.svg";
import { ReactComponent as SaveIcon } from "../assets/images/Icons/save-icon.svg";
import { ReactComponent as CartIcon } from "../assets/images/Icons/cart-icon.svg";
import { ReactComponent as ActivateCheckCircle } from "../assets/images/Icons/activate-check-circle.svg";
import { ReactComponent as DeleteRed } from "../assets/images/Icons/delete-red.svg";
import { ReactComponent as FilterTwoline } from "../assets/images/Icons/filter-two-line.svg";
import { ReactComponent as Upload } from "../assets/images/Icons/upload.svg";
import { ReactComponent as Copy } from "../assets/images/Icons/copy.svg";
import { ReactComponent as AddFolder } from "../assets/images/Icons/folder-add.svg";
import { ReactComponent as Folder } from "../assets/images/Icons/folder.svg";
import { ReactComponent as RemoveFolder } from "../assets/images/Icons/folder-minus.svg";
import { ReactComponent as Transfer } from "../assets/images/Icons/transfer.svg";
import { ReactComponent as MultipleContact } from "../assets/images/vendor/multipleContact.svg";
import { ReactComponent as PDFFile } from "../assets/images/Profile/icons/file.svg";
import { ReactComponent as MailSetting } from "../assets/images/Icons/mail-settings.svg";
import { ReactComponent as CurlyBrackets } from "../assets/images/Icons/brackets-curly.svg";
import { ReactComponent as Reset } from "../assets/images/Icons/reset.svg";
import { ReactComponent as Picklist } from "../assets/images/Icons/picklist.svg";
import { ReactComponent as DownloadFile } from "../assets/images/Icons/download-file.svg";

/* Menu Icon */
import { ReactComponent as MenuProduct } from "../assets/images/menu-icon/product.svg";
import { ReactComponent as MenuClone } from "../assets/images/menu-icon/clone.svg";
import { ReactComponent as MenuBuilding } from "../assets/images/menu-icon/building.svg";
import { ReactComponent as MenuShipping } from "../assets/images/menu-icon/shipping.svg";
import { ReactComponent as MenuDollar } from "../assets/images/menu-icon/dollar.svg";
import { ReactComponent as MenuCart } from "../assets/images/menu-icon/cart-icon.svg";
import { ReactComponent as MenuUser } from "../assets/images/menu-icon/user.svg";
import { ReactComponent as MenuFolder } from "../assets/images/menu-icon/folder.svg";
import { ReactComponent as MenuUserRole } from "../assets/images/menu-icon/user-role.svg";
import { ReactComponent as MenuMeasurement } from "../assets/images/menu-icon/measurement.svg";
import { ReactComponent as MenuLocation } from "../assets/images/menu-icon/location.svg";
import { ReactComponent as MenuPermission } from "../assets/images/menu-icon/permission.svg";
import { ReactComponent as MenuEmailProvider } from "../assets/images/menu-icon/email-provider.svg";
import { ReactComponent as MenuCalender } from "../assets/images/menu-icon/calender.svg";
import { ReactComponent as DeliveryTruck } from "../assets/images/menu-icon/delivery-truck.svg";
import { ReactComponent as CreditNotes } from "../assets/images/menu-icon/credit-notes.svg";
import { ReactComponent as SalesReturn } from "../assets/images/menu-icon/sales-return.svg";
import { ReactComponent as BackOrder } from "../assets/images/menu-icon/back-order.svg";
import { ReactComponent as Invoice } from "../assets/images/menu-icon/invoice.svg";
import { ReactComponent as Customers } from "../assets/images/menu-icon/customers.svg";
import { ReactComponent as PurchaseReceive } from "../assets/images/menu-icon/purchase-receive.svg";
import { ReactComponent as PurchaseOrder } from "../assets/images/menu-icon/purchase-order.svg";
import { ReactComponent as TransferOrder } from "../assets/images/menu-icon/transfer-order.svg";
import { ReactComponent as ItemCategory } from "../assets/images/menu-icon/item-category.svg";
import { ReactComponent as CustomerCategory } from "../assets/images/menu-icon/customer-category.svg";
import { ReactComponent as Approvers } from "../assets/images/menu-icon/approvers.svg";
import { ReactComponent as Territory } from "../assets/images/menu-icon/territory.svg";
import { ReactComponent as Manufacturer } from "../assets/images/menu-icon/manufacturer.svg";
import { ReactComponent as EmailTemplate } from "../assets/images/menu-icon/email-template.svg";
import { ReactComponent as CompositeItem } from "../assets/images/menu-icon/composite-item.svg";
import { ReactComponent as ItemGroup } from "../assets/images/menu-icon/item-group.svg";
import { ReactComponent as Item } from "../assets/images/menu-icon/item.svg";
import { ReactComponent as FulfillOrder } from "../assets/images/menu-icon/fulfill-order.svg";
import { ReactComponent as Logout } from "../assets/images/Profile/icons/logout.svg";

const SVGIcon = ({ icon, size = 24, className = "" }) => {
  const Icons = {
    blue_back_arrow: (
      <BlueBackArrow className={className} width={size} height={size} />
    ),
    email: <Email className={className} width={size} height={size} />,
    password: <Password className={className} width={size} height={size} />,
    check_mark: <CheckMark className={className} width={size} height={size} />,
    notification: (
      <Notification className={className} width={size} height={size} />
    ),
    dropdown_arrow: (
      <DropdownArrow className={className} width={size} height={size} />
    ),
    toggle_menu: (
      <ToggleMenu className={className} width={size} height={size} />
    ),
    cross: <Cross className={className} width={size} height={size} />,
    pin: <Pin className={className} width={size} height={size} />,
    dollar: <Dollar className={className} width={size} height={size} />,
    location: <Location className={className} width={size} height={size} />,
    right_tick_filled: (
      <RightTickFilled className={className} width={size} height={size} />
    ),
    error_filled: (
      <ErrorFilled className={className} width={size} height={size} />
    ),
    calender: <Calender className={className} width={size} height={size} />,
    add_circle: <AddCircle className={className} width={size} height={size} />,
    three_dots: <ThreeDots className={className} width={size} height={size} />,
    edit: <Edit className={className} width={size} height={size} />,
    delete: <Delete className={className} width={size} height={size} />,
    view: <View className={className} width={size} height={size} />,
    check_circle: (
      <CheckCircle className={className} width={size} height={size} />
    ),
    plus: <Plus className={className} width={size} height={size} />,
    link: <Link className={className} width={size} height={size} />,
    message: <Message className={className} width={size} height={size} />,
    down_arrow: <DownArrow className={className} width={size} height={size} />,
    arrow_left: <ArrowLeft className={className} width={size} height={size} />,
    add_form: <AddForm className={className} width={size} height={size} />,
    send_link: <SendLink className={className} width={size} height={size} />,
    resend_link: (
      <ResendLink className={className} width={size} height={size} />
    ),
    linkedIn: <LinkedIn className={className} width={size} height={size} />,
    not_allowed: (
      <NotAllowed className={className} width={size} height={size} />
    ),
    reactivate: <Reactivate className={className} width={size} height={size} />,
    download: <Download className={className} width={size} height={size} />,
    history: <History className={className} width={size} height={size} />,
    search: <Search className={className} width={size} height={size} />,
    select_arrow: (
      <SelectArrow className={className} width={size} height={size} />
    ),
    permission: <Permission className={className} width={size} height={size} />,
    info: <Information className={className} width={size} height={size} />,
    address: <Address className={className} width={size} height={size} />,
    banking: <Banking className={className} width={size} height={size} />,
    contact: <Contact className={className} width={size} height={size} />,
    building: <Building className={className} width={size} height={size} />,
    shipping_box: (
      <ShippingBox className={className} width={size} height={size} />
    ),
    phone: <Phone className={className} width={size} height={size} />,
    product: <Product className={className} width={size} height={size} />,
    branch: <Branch className={className} width={size} height={size} />,
    measurement: (
      <UnitOfMeasurement className={className} width={size} height={size} />
    ),
    userRole: <UserRole className={className} width={size} height={size} />,
    user: <User className={className} width={size} height={size} />,
    salesDetail: (
      <SalesDetail className={className} width={size} height={size} />
    ),
    warning: <Warning className={className} width={size} height={size} />,
    clone: <Clone className={className} width={size} height={size} />,
    markasinavtive: (
      <MarkAsInactive className={className} width={size} height={size} />
    ),
    saveicon: <SaveIcon className={className} width={size} height={size} />,
    carticon: <CartIcon className={className} width={size} height={size} />,
    activate_check_circle: (
      <ActivateCheckCircle className={className} width={size} height={size} />
    ),
    delete_red: <DeleteRed className={className} width={size} height={size} />,
    filter_small: (
      <FilterTwoline className={className} width={size} height={size} />
    ),
    upload: <Upload className={className} width={size} height={size} />,
    copy: <Copy className={className} width={size} height={size} />,
    add_folder: <AddFolder className={className} width={size} height={size} />,
    folder: <Folder className={className} width={size} height={size} />,
    remove_folder: (
      <RemoveFolder className={className} width={size} height={size} />
    ),
    transfer: <Transfer className={className} width={size} height={size} />,
    multipleContact: (
      <MultipleContact className={className} width={size} height={size} />
    ),
    pdfFile: <PDFFile className={className} width={size} height={size} />,
    mail_setting: (
      <MailSetting className={className} width={size} height={size} />
    ),
    curly_brackets: (
      <CurlyBrackets className={className} width={size} height={size} />
    ),
    reset: <Reset className={className} width={size} height={size} />,
    picklist: <Picklist className={className} width={size} height={size} />,
    download_file: (
      <DownloadFile className={className} width={size} height={size} />
    ),

    /**********  Menu Icon *********/
    /*******************************/
    menu_product: (
      <MenuProduct className={className} width={size} height={size} />
    ),
    menu_clone: <MenuClone className={className} width={size} height={size} />,
    menu_building: (
      <MenuBuilding className={className} width={size} height={size} />
    ),
    menu_shipping: (
      <MenuShipping className={className} width={size} height={size} />
    ),
    menu_dollar: (
      <MenuDollar className={className} width={size} height={size} />
    ),
    menu_cart: <MenuCart className={className} width={size} height={size} />,
    menu_user: <MenuUser className={className} width={size} height={size} />,
    menu_folder: (
      <MenuFolder className={className} width={size} height={size} />
    ),
    menu_user_role: (
      <MenuUserRole className={className} width={size} height={size} />
    ),
    menu_measurement: (
      <MenuMeasurement className={className} width={size} height={size} />
    ),
    menu_location: (
      <MenuLocation className={className} width={size} height={size} />
    ),
    menu_permission: (
      <MenuPermission className={className} width={size} height={size} />
    ),
    menu_email_provider: (
      <MenuEmailProvider className={className} width={size} height={size} />
    ),
    menu_calender: (
      <MenuCalender className={className} width={size} height={size} />
    ),
    menu_delivery_truck: (
      <DeliveryTruck className={className} width={size} height={size} />
    ),
    menu_credit_notes: (
      <CreditNotes className={className} width={size} height={size} />
    ),
    menu_sales_return: (
      <SalesReturn className={className} width={size} height={size} />
    ),
    menu_back_order: (
      <BackOrder className={className} width={size} height={size} />
    ),
    menu_invoice: <Invoice className={className} width={size} height={size} />,
    menu_customers: (
      <Customers className={className} width={size} height={size} />
    ),
    menu_purchase_receive: (
      <PurchaseReceive className={className} width={size} height={size} />
    ),
    menu_purchase_order: (
      <PurchaseOrder className={className} width={size} height={size} />
    ),
    transfer_order: (
      <TransferOrder className={className} width={size} height={size} />
    ),
    item_category: (
      <ItemCategory className={className} width={size} height={size} />
    ),
    customer_category: (
      <CustomerCategory className={className} width={size} height={size} />
    ),
    approvers: <Approvers className={className} width={size} height={size} />,
    territory: <Territory className={className} width={size} height={size} />,
    manufacturer: (
      <Manufacturer className={className} width={size} height={size} />
    ),
    email_template: (
      <EmailTemplate className={className} width={size} height={size} />
    ),
    composite_item: (
      <CompositeItem className={className} width={size} height={size} />
    ),
    item_group: <ItemGroup className={className} width={size} height={size} />,
    item: <Item className={className} width={size} height={size} />,
    fulfill_order: (
      <FulfillOrder className={className} width={size} height={size} />
    ),
    logout: <Logout className={className} width={size} height={size} />,
  };
  return Icons[icon];
};

export default SVGIcon;
